import { Title } from '@gerdau/hefesto';
import { Accordion } from '@gerdau/hefesto-mais-web/Accordion';
import { DataProps } from '@gerdau/hefesto-mais-web/Accordion/Accordion.types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { EHelpCenterRoutes } from '../../pages/HelpCenter/helpCenter.routes';
import { ERoutes } from '../../routes';
import GoBackButtonFacelift from '../GoBackButton/Facelift';
import { IQuestionAnswerPage } from './helpCenterQuestions';
import { AccordionContainer, QuestionsAnswersContainer } from './styles';

export const QuestionsAnswers: React.FC<IQuestionAnswerPage> = ({
  questions,
  title
}) => {
  const history = useHistory();

  const getAccordionData = (): DataProps[] => {
    return questions.map((item, id) => ({
      title: item.question,
      content: item.answer,
      id
    }));
  };

  return (
    <QuestionsAnswersContainer>
      <GoBackButtonFacelift
        onClick={() =>
          history.push(
            `${ERoutes.HELP_CENTER}${EHelpCenterRoutes.COMMON_QUESTIONS}`
          )
        }
        title="Voltar"
      ></GoBackButtonFacelift>
      <Title level={3}>{title}</Title>
      <AccordionContainer>
        {getAccordionData().map((data) => (
          <Accordion key={data.id} data={[data]} />
        ))}
      </AccordionContainer>
    </QuestionsAnswersContainer>
  );
};
